import * as React from 'react';
import tinycolor from 'tinycolor2';
import styled from 'styled-components';
import { Alpha as AlphaBase } from 'react-color/lib/components/common';

import { CustomPointer } from '@process-advisor/process-miner/components/colorPicker/customPointer';

const AlphaContainer = styled.div`
    margin-top: 4px;
    height: 10px;
    width: 100%;
    border-radius: 5px;
    position: relative;
`;

type Props = {
    activeColor: string;
    onColorChange: (color: string) => void;
};

export const Alpha: React.FC<Props> = ({ activeColor, onColorChange }) => (
    <AlphaContainer>
        <AlphaBase
            hsl={tinycolor(activeColor).toHsl()}
            rgb={tinycolor(activeColor).toRgb()}
            onChange={({ h, s, l, a }) => {
                const color = tinycolor({ h, s, l, a }).toHex8String();
                onColorChange(color);
            }}
            pointer={CustomPointer} />
    </AlphaContainer>
);
